<div class="planning-controls" role="toolbar" [attr.aria-label]="'PLANNING.CONTROLS' | translate">

  <div class="planning-controls__modes" role="tablist">
    <button
      type="button"
      role="tab"
      class="planning-controls__mode"
      [class.planning-controls__mode--active]="mode() === 'drilling'"
      [attr.aria-selected]="mode() === 'drilling'"
      (click)="modeChange.emit('drilling')"
      data-attr="area-planning-mode-drilling">
      {{ 'PLANNING.DRILLING' | translate }}
    </button>
    <button
      type="button"
      role="tab"
      class="planning-controls__mode"
      [class.planning-controls__mode--active]="mode() === 'delivery'"
      [attr.aria-selected]="mode() === 'delivery'"
      (click)="modeChange.emit('delivery')"
      data-attr="area-planning-mode-delivery">
      {{ 'PLANNING.DELIVERY' | translate }}
    </button>
  </div>

  <div class="planning-controls__field planning-controls__field--colorby">
    <app-select
      [options]="colorByOptions()"
      [ngModel]="colorBy()"
      (selectionChange)="onColorBy($event)"
      size="medium"
      data-attr="area-planning-colorby">
    </app-select>
  </div>

  <div class="planning-controls__field planning-controls__field--month">
    <app-date-picker
      [value]="date()"
      (valueChange)="onDatePick($event)"
      [markedDates]="markedDates()"
      (visibleRangeChange)="visibleRangeChange.emit($event)"
      data-attr="area-planning-date" />
  </div>

  <div class="planning-controls__field planning-controls__field--scale">
    <app-select
      [options]="timeScaleOptions()"
      [ngModel]="timeScale()"
      (selectionChange)="onTimeScale($event)"
      size="medium"
      data-attr="area-planning-scale">
    </app-select>
  </div>

  <div class="planning-controls__nav">
    <button
      type="button"
      class="planning-controls__arrow"
      [attr.aria-label]="'PLANNING.PREVIOUS' | translate"
      (click)="navigate.emit(-1)"
      data-attr="area-planning-nav-prev">
      <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M10.5 2.5 5 8l5.5 5.5" /></svg>
    </button>

    <app-button
      [label]="'PLANNING.TODAY' | translate"
      variant="secondary"
      size="small"
      (clicked)="todayClick.emit()"
      data-attr="area-planning-today">
    </app-button>

    <button
      type="button"
      class="planning-controls__arrow"
      [attr.aria-label]="'PLANNING.NEXT' | translate"
      (click)="navigate.emit(1)"
      data-attr="area-planning-nav-next">
      <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M5.5 2.5 11 8l-5.5 5.5" /></svg>
    </button>
  </div>

  @if (mode() === 'delivery') {
    <div class="planning-controls__report" [title]="'PLANNING.REPORT_HINT' | translate">
      <app-button
        [label]="'PLANNING.DELIVERY_REPORT' | translate"
        [addIconLeft]="true"
        size="small"
        [state]="reportDisabled() ? 'disabled' : 'default'"
        (clicked)="reportClick.emit()"
        data-attr="area-planning-report">
        <img slot="icon-left" src="./../../assets/icon/new_icon/report.svg" />
      </app-button>
    </div>
  }

</div>
